var cov_1v4cj3lbdt = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Select/Option.tsx",
      hash = "856985134b705511a38cb531f84750031f134e0f",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Select/Option.tsx",
    statementMap: {
      "0": {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 16,
          column: 16
        }
      },
      "1": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 17,
          column: 50
        }
      },
      "2": {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 18,
          column: 50
        }
      },
      "3": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 42
        }
      },
      "4": {
        start: {
          line: 22,
          column: 31
        },
        end: {
          line: 22,
          column: 42
        }
      },
      "5": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 97
        }
      },
      "6": {
        start: {
          line: 23,
          column: 86
        },
        end: {
          line: 23,
          column: 97
        }
      },
      "7": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 16
        }
      },
      "8": {
        start: {
          line: 28,
          column: 60
        },
        end: {
          line: 28,
          column: 70
        }
      },
      "9": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 81
        }
      },
      "10": {
        start: {
          line: 30,
          column: 75
        },
        end: {
          line: 30,
          column: 81
        }
      },
      "11": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 31,
          column: 22
        }
      },
      "12": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 33,
          column: 28
        }
      },
      "13": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 37,
          column: 11
        }
      },
      "14": {
        start: {
          line: 36,
          column: 6
        },
        end: {
          line: 36,
          column: 25
        }
      },
      "15": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 40
        }
      },
      "16": {
        start: {
          line: 45,
          column: 79
        },
        end: {
          line: 45,
          column: 89
        }
      },
      "17": {
        start: {
          line: 46,
          column: 25
        },
        end: {
          line: 46,
          column: 61
        }
      },
      "18": {
        start: {
          line: 47,
          column: 22
        },
        end: {
          line: 56,
          column: 5
        }
      },
      "19": {
        start: {
          line: 58,
          column: 19
        },
        end: {
          line: 58,
          column: 102
        }
      },
      "20": {
        start: {
          line: 59,
          column: 18
        },
        end: {
          line: 59,
          column: 58
        }
      },
      "21": {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 63,
          column: 5
        }
      },
      "22": {
        start: {
          line: 62,
          column: 6
        },
        end: {
          line: 62,
          column: 73
        }
      },
      "23": {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 70,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 15,
            column: 3
          }
        },
        loc: {
          start: {
            line: 15,
            column: 40
          },
          end: {
            line: 19,
            column: 3
          }
        },
        line: 15
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 21,
            column: 3
          }
        },
        loc: {
          start: {
            line: 21,
            column: 70
          },
          end: {
            line: 25,
            column: 3
          }
        },
        line: 21
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        },
        loc: {
          start: {
            line: 27,
            column: 16
          },
          end: {
            line: 38,
            column: 3
          }
        },
        line: 27
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 35,
            column: 15
          },
          end: {
            line: 35,
            column: 16
          }
        },
        loc: {
          start: {
            line: 35,
            column: 21
          },
          end: {
            line: 37,
            column: 5
          }
        },
        line: 35
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 40,
            column: 3
          }
        },
        loc: {
          start: {
            line: 40,
            column: 16
          },
          end: {
            line: 42,
            column: 3
          }
        },
        line: 40
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 44,
            column: 2
          },
          end: {
            line: 44,
            column: 3
          }
        },
        loc: {
          start: {
            line: 44,
            column: 11
          },
          end: {
            line: 71,
            column: 3
          }
        },
        line: 44
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 22,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 22,
            column: 42
          }
        }, {
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 22,
            column: 42
          }
        }],
        line: 22
      },
      "1": {
        loc: {
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 23,
            column: 97
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 23,
            column: 97
          }
        }, {
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 23,
            column: 97
          }
        }],
        line: 23
      },
      "2": {
        loc: {
          start: {
            line: 23,
            column: 8
          },
          end: {
            line: 23,
            column: 84
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 23,
            column: 8
          },
          end: {
            line: 23,
            column: 44
          }
        }, {
          start: {
            line: 23,
            column: 48
          },
          end: {
            line: 23,
            column: 84
          }
        }],
        line: 23
      },
      "3": {
        loc: {
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 30,
            column: 81
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 30,
            column: 81
          }
        }, {
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 30,
            column: 81
          }
        }],
        line: 30
      },
      "4": {
        loc: {
          start: {
            line: 30,
            column: 8
          },
          end: {
            line: 30,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 30,
            column: 8
          },
          end: {
            line: 30,
            column: 19
          }
        }, {
          start: {
            line: 30,
            column: 23
          },
          end: {
            line: 30,
            column: 31
          }
        }, {
          start: {
            line: 30,
            column: 36
          },
          end: {
            line: 30,
            column: 40
          }
        }, {
          start: {
            line: 30,
            column: 44
          },
          end: {
            line: 30,
            column: 72
          }
        }],
        line: 30
      },
      "5": {
        loc: {
          start: {
            line: 46,
            column: 25
          },
          end: {
            line: 46,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 46,
            column: 25
          },
          end: {
            line: 46,
            column: 29
          }
        }, {
          start: {
            line: 46,
            column: 33
          },
          end: {
            line: 46,
            column: 61
          }
        }],
        line: 46
      },
      "6": {
        loc: {
          start: {
            line: 50,
            column: 8
          },
          end: {
            line: 50,
            column: 28
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 50,
            column: 8
          },
          end: {
            line: 50,
            column: 16
          }
        }, {
          start: {
            line: 50,
            column: 20
          },
          end: {
            line: 50,
            column: 28
          }
        }],
        line: 50
      },
      "7": {
        loc: {
          start: {
            line: 51,
            column: 8
          },
          end: {
            line: 51,
            column: 26
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 51,
            column: 8
          },
          end: {
            line: 51,
            column: 15
          }
        }, {
          start: {
            line: 51,
            column: 19
          },
          end: {
            line: 51,
            column: 26
          }
        }],
        line: 51
      },
      "8": {
        loc: {
          start: {
            line: 52,
            column: 8
          },
          end: {
            line: 52,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 52,
            column: 8
          },
          end: {
            line: 52,
            column: 16
          }
        }, {
          start: {
            line: 52,
            column: 20
          },
          end: {
            line: 52,
            column: 49
          }
        }],
        line: 52
      },
      "9": {
        loc: {
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 53,
            column: 31
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 53,
            column: 20
          }
        }, {
          start: {
            line: 53,
            column: 24
          },
          end: {
            line: 53,
            column: 31
          }
        }],
        line: 53
      },
      "10": {
        loc: {
          start: {
            line: 58,
            column: 19
          },
          end: {
            line: 58,
            column: 102
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 58,
            column: 34
          },
          end: {
            line: 58,
            column: 62
          }
        }, {
          start: {
            line: 58,
            column: 65
          },
          end: {
            line: 58,
            column: 102
          }
        }],
        line: 58
      },
      "11": {
        loc: {
          start: {
            line: 59,
            column: 18
          },
          end: {
            line: 59,
            column: 58
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 59,
            column: 47
          },
          end: {
            line: 59,
            column: 53
          }
        }, {
          start: {
            line: 59,
            column: 56
          },
          end: {
            line: 59,
            column: 58
          }
        }],
        line: 59
      },
      "12": {
        loc: {
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 63,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 63,
            column: 5
          }
        }, {
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 63,
            column: 5
          }
        }],
        line: 61
      },
      "13": {
        loc: {
          start: {
            line: 61,
            column: 8
          },
          end: {
            line: 61,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 61,
            column: 8
          },
          end: {
            line: 61,
            column: 22
          }
        }, {
          start: {
            line: 61,
            column: 26
          },
          end: {
            line: 61,
            column: 41
          }
        }],
        line: 61
      },
      "14": {
        loc: {
          start: {
            line: 68,
            column: 9
          },
          end: {
            line: 68,
            column: 32
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 68,
            column: 9
          },
          end: {
            line: 68,
            column: 17
          }
        }, {
          start: {
            line: 68,
            column: 21
          },
          end: {
            line: 68,
            column: 32
          }
        }],
        line: 68
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Select/Option.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import { selectClass } from './styles';
import { isObject } from '../utils/is';
import shallowEqual from '../utils/shallowEqual';
import icons from '../icons';
import { getDirectionClass } from '../utils/classname';

var Option =
/*#__PURE__*/
function (_ref) {
  _inherits(Option, _ref);

  var _super = _createSuper2(Option);

  function Option(props) {
    var _this;

    _classCallCheck(this, Option);

    cov_1v4cj3lbdt.f[0]++;
    cov_1v4cj3lbdt.s[0]++;
    _this = _super.call(this, props);
    _this.locked = void 0;
    _this.handleEnter = void 0;
    cov_1v4cj3lbdt.s[1]++;
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    cov_1v4cj3lbdt.s[2]++;
    _this.handleEnter = _this.handleHover.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Option, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      cov_1v4cj3lbdt.f[1]++;
      cov_1v4cj3lbdt.s[3]++;

      if (this.props.filterText) {
        cov_1v4cj3lbdt.b[0][0]++;
        cov_1v4cj3lbdt.s[4]++;
        return true;
      } else {
        cov_1v4cj3lbdt.b[0][1]++;
      }

      cov_1v4cj3lbdt.s[5]++;

      if ((cov_1v4cj3lbdt.b[2][0]++, !shallowEqual(nextProps, this.props)) || (cov_1v4cj3lbdt.b[2][1]++, !shallowEqual(nextState, this.state))) {
        cov_1v4cj3lbdt.b[1][0]++;
        cov_1v4cj3lbdt.s[6]++;
        return true;
      } else {
        cov_1v4cj3lbdt.b[1][1]++;
      }

      cov_1v4cj3lbdt.s[7]++;
      return false;
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var _this2 = this;

      cov_1v4cj3lbdt.f[2]++;

      var _ref2 = (cov_1v4cj3lbdt.s[8]++, this.props),
          data = _ref2.data,
          onClick = _ref2.onClick,
          isActive = _ref2.isActive,
          disabled = _ref2.disabled,
          groupKey = _ref2.groupKey;

      cov_1v4cj3lbdt.s[9]++;

      if ((cov_1v4cj3lbdt.b[4][0]++, this.locked) || (cov_1v4cj3lbdt.b[4][1]++, disabled) || (cov_1v4cj3lbdt.b[4][2]++, data) && (cov_1v4cj3lbdt.b[4][3]++, data[groupKey])) {
        cov_1v4cj3lbdt.b[3][0]++;
        cov_1v4cj3lbdt.s[10]++;
        return;
      } else {
        cov_1v4cj3lbdt.b[3][1]++;
      }

      cov_1v4cj3lbdt.s[11]++;
      this.locked = true;
      cov_1v4cj3lbdt.s[12]++;
      onClick(!isActive, data);
      cov_1v4cj3lbdt.s[13]++;
      setTimeout(function () {
        cov_1v4cj3lbdt.f[3]++;
        cov_1v4cj3lbdt.s[14]++;
        _this2.locked = false;
      }, 200);
    }
  }, {
    key: "handleHover",
    value: function handleHover() {
      cov_1v4cj3lbdt.f[4]++;
      cov_1v4cj3lbdt.s[15]++;
      this.props.onHover(this.props.index);
    }
  }, {
    key: "render",
    value: function render() {
      cov_1v4cj3lbdt.f[5]++;

      var _ref3 = (cov_1v4cj3lbdt.s[16]++, this.props),
          data = _ref3.data,
          isActive = _ref3.isActive,
          index = _ref3.index,
          renderItem = _ref3.renderItem,
          isHover = _ref3.isHover,
          disabled = _ref3.disabled,
          groupKey = _ref3.groupKey;

      var isGroupTitle = (cov_1v4cj3lbdt.s[17]++, (cov_1v4cj3lbdt.b[5][0]++, data) && (cov_1v4cj3lbdt.b[5][1]++, data[groupKey]));
      var className = (cov_1v4cj3lbdt.s[18]++, classnames(selectClass(getDirectionClass('option'), (cov_1v4cj3lbdt.b[6][0]++, isActive) && (cov_1v4cj3lbdt.b[6][1]++, 'active'), (cov_1v4cj3lbdt.b[7][0]++, isHover) && (cov_1v4cj3lbdt.b[7][1]++, 'hover'), (cov_1v4cj3lbdt.b[8][0]++, disabled) && (cov_1v4cj3lbdt.b[8][1]++, getDirectionClass('disabled')), (cov_1v4cj3lbdt.b[9][0]++, isGroupTitle) && (cov_1v4cj3lbdt.b[9][1]++, 'group')), "option-".concat(index)));
      var result = (cov_1v4cj3lbdt.s[19]++, isGroupTitle ? (cov_1v4cj3lbdt.b[10][0]++, data[groupKey]) : (cov_1v4cj3lbdt.b[10][1]++, renderItem(data, index)));
      var title = (cov_1v4cj3lbdt.s[20]++, typeof result === 'string' ? (cov_1v4cj3lbdt.b[11][0]++, result) : (cov_1v4cj3lbdt.b[11][1]++, ''));
      cov_1v4cj3lbdt.s[21]++;

      if ((cov_1v4cj3lbdt.b[13][0]++, isObject(data)) && (cov_1v4cj3lbdt.b[13][1]++, result === data)) {
        cov_1v4cj3lbdt.b[12][0]++;
        cov_1v4cj3lbdt.s[22]++;
        console.warn('renderItem is essential when data element is Object');
      } else {
        cov_1v4cj3lbdt.b[12][1]++;
      }

      cov_1v4cj3lbdt.s[23]++;
      return (
        /*#__PURE__*/
        React.createElement("a", {
          tabIndex: -1,
          onClick: this.handleClick,
          onMouseEnter: this.handleEnter,
          className: className,
          title: title,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 66,
            columnNumber: 7
          }
        }, result, (cov_1v4cj3lbdt.b[14][0]++, isActive) && (cov_1v4cj3lbdt.b[14][1]++, icons.Check))
      );
    }
  }]);

  return Option;
}((React.Component));

export default Option;